import { useUnit } from 'effector-react';
import { soundsMaster } from 'shared/lib';
import SoundOffIcon from 'shared/ui/assets/icons/sound-off-icon.svg?react';
import SoundOnIcon from 'shared/ui/assets/icons/sound-on-icon.svg?react';
import { SidebarSlider } from '../sidebar-slider';

export const SidebarSoundsSlider = () => {
	const [volume, setVolume] = useUnit([soundsMaster.$volume, soundsMaster.setVolume]);

	return (
		<SidebarSlider
			iconOn={<SoundOnIcon />}
			iconOff={<SoundOffIcon />}
			value={volume}
			onChange={setVolume}
		/>
	);
};
